import { EventEmitter } from 'events';
import LoginEvent, { AlreadyLogin, LoginSuccess, Logout, NeedLogin } from '@/events/login-event';

export const TriggerAlarm = 'trigger-alarm';

export const PermissionChange = 'permission-change';

export const DeviceStatusChange = 'device-status-change';

export const SyncComplete = 'sync-complete';

/**
 * 报警事件
 */
const PushEvent = new EventEmitter();

let pushService: null | (() => void) = null;
let timer: number | null = null;
const createWebSocketConnection = () => {
  if (timer != null) {
    clearTimeout(timer);
    timer = null;
  }

  const host = location.hostname;
  const port = location.port;
  let protocol = 'ws';
  if (location.protocol.startsWith('https')) {
    protocol = 'wss';
  }

  const websocket = new WebSocket(`${protocol}://${host}:${port}/ws/message`);
  let destroy = false;
  websocket.onopen = () => {
    console.log('推送服务已连接');
  };
  websocket.onclose = e => {
    console.log('推送服务已断开');
    if (!destroy) {
      timer = setTimeout(() => {
        pushService = createWebSocketConnection();
      }, 5000);
    }
  };
  websocket.onmessage = e => {
    if (typeof e.data === 'string') {
      const data = JSON.parse(e.data);
      switch (data.type) {
        case 0:
          PushEvent.emit(TriggerAlarm, data.data);
          break;
        case 1:
          PushEvent.emit(PermissionChange);
          break;
        case 2:
          PushEvent.emit(DeviceStatusChange, data.data);
          break;
        case 3:
          PushEvent.emit(SyncComplete);
          break;
      }
    }
  };
  websocket.onerror = e => {
    console.error('推送服务连接错误', e);
  };

  return () => {
    destroy = true;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    websocket.close();
  };
};

const closeService = () => {
  if (pushService) {
    pushService();
    pushService = null;
  }
};

LoginEvent.on(NeedLogin, () => {
  closeService();
});
LoginEvent.once(AlreadyLogin, () => {
  closeService();
  pushService = createWebSocketConnection();
});
LoginEvent.on(LoginSuccess, () => {
  closeService();
  pushService = createWebSocketConnection();
});
LoginEvent.on(Logout, () => {
  closeService();
});

export default PushEvent;
